import { render } from "./MainMessageItem.vue?vue&type=template&id=6035be5c&scoped=true"
import script from "./MainMessageItem.vue?vue&type=script&lang=js"
export * from "./MainMessageItem.vue?vue&type=script&lang=js"

import "./MainMessageItem.vue?vue&type=style&index=0&id=6035be5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6035be5c"]])

export default __exports__